import { apiClient } from './Client';
import { IAuth } from 'modules/Auth/typings';

const login = (token: string): Promise<IAuth> => {
  return apiClient
    .post<IAuth>('/auth/login', {
      body: {
        token,
        locale: navigator.language,
      },
    })
    .then((res: IAuth) => res);
};

export default {
  login,
};
